module.exports = __webpack_public_path__ + "img/dummy11.b66508e.jpg";